import { useTranslation } from 'react-i18next';

import { PageLayout, PageTitle } from 'core/components';
import { SelectionCountProvider } from 'core/states';
import { ElementTemplateList } from 'elements/components';

export const ElementTemplateListPage = () => {
  const { t } = useTranslation();

  return (
    <PageLayout title={t('titleElementTemplates')}>
      <PageTitle title={t('titleElementTemplates')} />
      <SelectionCountProvider>
        <ElementTemplateList />
      </SelectionCountProvider>
    </PageLayout>
  );
};
